import React from 'react';
import TWICLCertificationsFilterDropdownItem from './TWICLCertificationsFilterDropdownItem';
import PropTypes from 'prop-types';

function TWICLCertificationsFilterDropdown({search}) {


    let schemeTypes = [ 'Personnel', 'Company', 'Training', 'End Point Assessment (EPA)' ];   
   
	return (

        <div className="filter-bar">

            <div className="filter filter__dropdown">
                <TWICLCertificationsFilterDropdownItem search={search} title="SchemeType" options={schemeTypes} />
            </div>


        </div>
        
	);
}

TWICLCertificationsFilterDropdown.propTypes = {
    search: PropTypes.object,
    settings: PropTypes.object,
    filters: PropTypes.object,
    entries: PropTypes.object,
	options: PropTypes.object,
	title: PropTypes.string
};

export default TWICLCertificationsFilterDropdown;